<template>
  <div class="HintsTemplate animated fadeIn">
    <label class="HintsTemplate__important">Wybrana opcja:</label>
    Kieruj połączenie do wybranych konsultantów.
    <ol class="HintsTemplate__description HintsTemplate__list">
      <li>System <b>call web</b> zadzwoni do wszystkich zaznaczonych konsultantów.</li>
      <li>
        Konsultant, który odbierze połączenie, usłyszy informację, że połączenie następuje z systemu <b>call web</b> i poprosi o potwierdzenie
        przyjęcia połączenia.
      </li>
      <li>Po poprawnym potwierdzeniu, nastąpi połączenie pomiędzy Konsultantem a użytkownikiem strony internetowej.</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'AgentsGroupInhoursBehavior',
};
</script>
